interface BaseProductPlan {
  interval: 'month' | 'year';
  intervalCount: number;
  name: string;
  package: string;
  price: string;
  slug: string;
  trialPeriodDays: number;
  uuid: string;
}

interface MonthlyProductPlan extends BaseProductPlan {
  interval: 'month';
  intervalCount: 1;
}

interface QuarterlyProductPlan extends BaseProductPlan {
  interval: 'month';
  intervalCount: 3;
}

interface TwoYearProductPlan extends BaseProductPlan {
  interval: 'month';
  intervalCount: 24;
}

interface YearlyProductPlan extends BaseProductPlan {
  interval: 'year';
  intervalCount: 1;
}

export type ProductPlan = MonthlyProductPlan | QuarterlyProductPlan | YearlyProductPlan | TwoYearProductPlan;

export enum ProductPlanFields {
  billingPeriod = 'billingPeriod',
  selectedPackageSlug = 'selectedPackageSlug',
  selectedPlanSlug = 'selectedPlanSlug',
  selectedPremiumFeatures = 'selectedPremiumFeatures',
}

export interface ProductFeature {
  availablePackages: string[];
  basePrice: string;
  description?: string;
  isHidden?: boolean;
  name: string;
  slug: string;
  uuid: string;
}

export interface ProductPackage {
  checkoutUrl: string;
  description: string;
  features: string[];
  name: string;
  plans: ProductPlan[];
  slug: string;
  uuid: string;
}

export interface Product {
  features: ProductFeature[];
  name: string;
  packages: ProductPackage[];
  plans: ProductPlan[];
  premiumFeatures: ProductFeature[];
  slug: string;
  uuid: string;
}
